import React from 'react';

export const ChipInternacionalIcon = ({ size = 16, color = '#5A539C', className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(size * 11.8946) / 17.3}
    height={size}
    viewBox="0 0 11.8946 17.3"
    fill="none"
    className={className}
  >
    <path
      d="M2.37973 0.65H6.87703C7.33504 0.651931 7.77359 0.835437 8.09649 1.16027L10.7343 3.79811C11.0592 4.12101 11.2427 4.55956 11.2446 5.01757V14.9203C11.2446 15.379 11.0624 15.819 10.738 16.1434C10.4136 16.4678 9.97362 16.65 9.51487 16.65H2.37973C1.92098 16.65 1.48101 16.4678 1.15663 16.1434C0.832239 15.819 0.65 15.379 0.65 14.9203V2.37973C0.65 1.92098 0.832239 1.48101 1.15663 1.15663C1.48101 0.832239 1.92098 0.65 2.37973 0.65Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83877 7.29828C7.54026 7.29828 8.9196 8.67789 8.91982 10.3793C8.91982 12.081 7.5404 13.4604 5.83877 13.4604C4.13732 13.4602 2.75771 12.0808 2.75771 10.3793C2.75794 8.67803 4.13746 7.2985 5.83877 7.29828Z"
      stroke={color}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83959 7.29828C6.13354 7.2984 6.38148 7.4375 6.57201 7.6225C6.76076 7.80582 6.91324 8.05201 7.03197 8.32465C7.26978 8.871 7.40692 9.59777 7.40697 10.3793C7.40697 11.1611 7.26986 11.8885 7.03197 12.435C6.91324 12.7076 6.76076 12.9538 6.57201 13.1371C6.38149 13.3221 6.13351 13.4603 5.83959 13.4604C5.54544 13.4604 5.29681 13.3222 5.10619 13.1371C4.91743 12.9538 4.76593 12.7076 4.6472 12.435C4.40923 11.8885 4.27123 11.1613 4.27123 10.3793C4.27127 9.59763 4.40931 8.87103 4.6472 8.32465C4.76593 8.05201 4.91743 7.80582 5.10619 7.6225C5.29681 7.43737 5.54541 7.29828 5.83959 7.29828Z"
      stroke={color}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.28783 9.60133H8.39053M3.28783 11.1581H8.39053"
      stroke={color}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/ChipInternacional.icon.jsx